(function () {
  function getConfig() {
    const cfg = window.RivyoConfig || {};
    if (!cfg.proxyUrl || !cfg.shop || !cfg.product || !cfg.product.id || !cfg.product.handle) {
      return null;
    }
    return cfg;
  }

  function getProductSchemaTarget() {
    const scripts = document.querySelectorAll('script[type="application/ld+json"]');
    for (const script of scripts) {
      let parsed;
      try {
        parsed = JSON.parse(script.textContent || "");
      } catch (error) {
        continue;
      }

      if (Array.isArray(parsed)) {
        const index = parsed.findIndex((item) => item && item["@type"] === "Product");
        if (index !== -1) return { script, parsed, index, isArray: true };
      } else if (parsed && parsed["@type"] === "Product") {
        return { script, parsed, index: -1, isArray: false };
      }
    }
    return null;
  }

  async function fetchRivyoRating(cfg) {
    const shared = window.RivyoShared || {};
    let payload = null;

    if (typeof shared.getProductReviews === "function") {
      payload = await shared.getProductReviews(
        cfg,
        String(cfg.product.id),
        String(cfg.product.handle),
        { sortBy: "recent-review", page: 1 }
      );
    } else {
      const endpoint = new URL(cfg.proxyUrl);
      endpoint.searchParams.set("action", "product_reviews");
      endpoint.searchParams.set("shop", cfg.shop);
      endpoint.searchParams.set("product_id", String(cfg.product.id));
      endpoint.searchParams.set("product_handle", String(cfg.product.handle));

      const response = await fetch(endpoint.toString(), { method: "GET" });
      if (!response.ok) return null;
      payload = await response.json();
    }

    if (!payload) return null;

    const ratingValue = Number(payload.base_rating);
    const ratingCount = Number(payload.total_review);
    if (!Number.isFinite(ratingValue) || !Number.isFinite(ratingCount) || ratingCount <= 0) {
      return null;
    }

    return {
      "@type": "AggregateRating",
      ratingValue: Number(ratingValue.toFixed(2)),
      ratingCount: Math.round(ratingCount),
    };
  }

  async function init() {
    const cfg = getConfig();
    if (!cfg) return;

    const rating = await fetchRivyoRating(cfg).catch(() => null);
    if (!rating) return;

    const target = getProductSchemaTarget();
    if (!target) return;

    if (target.isArray) {
      target.parsed[target.index].aggregateRating = rating;
      target.script.textContent = JSON.stringify(target.parsed);
      return;
    }

    target.parsed.aggregateRating = rating;
    target.script.textContent = JSON.stringify(target.parsed);
  }

  if (window.loadScheduler && typeof window.loadScheduler.onDomContentLoaded === "function") {
    window.loadScheduler.onDomContentLoaded(init);
    return;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
